import styled from "styled-components";

export const MusicInstrumentDetailContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .title {
    margin-bottom: 26px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
  }
`;
